import type { AxiosResponse } from "axios";

import http from "@/api/instance";

type NotificationReadByIdResponseType = { data: number };

type NotificationReadByIdRequestType = (args: id) => Promise<AxiosResponse<NotificationReadByIdResponseType>>;

export const readNotificationById: NotificationReadByIdRequestType = (id) => http.httpCore.post(`notifications/${id}/read`);
